import { IS_LOCAL } from '@/core/platform/constants';
import { getTLD } from '@/core/settings/utils';
import logger from '@/domains/core/observability/logger';

export const isValidRedirectUrl = (redirectUrl: string | undefined) => {
  try {
    /** Current TLD suffix with escaped dots. */
    const tld = getTLD().replace(/\./g, '\\.');
    /** Expression for URIs considered valid. */
    const validRe = new RegExp(`^https://.*\\.manomano${tld}$`);

    if (!redirectUrl) return false;

    if (/\\|@/.test(decodeURI(redirectUrl))) return false;

    if (IS_LOCAL) return true;

    const { origin } = new URL(redirectUrl);
    return validRe.test(origin);
  } catch (error) {
    error.message = `Error validating redirect URL: ${redirectUrl}; ${error.message}`;
    logger.error(error);
    return false;
  }
};
